<template>
    <b-modal
        :id="`modal-add-product-to-group`"
        ref="modal"
        :title="$t('addProductToGroup')"
        size="xl"
        static
        centered
        hide-footer
        @ok.prevent="handleSubmit()"
        @show="resetData()"
        @hidden="resetData()"
    >
        <DataTable
            :fields="fields"
            :items="requestProductGroups.getLoading() ? [] : items"
            :loading="requestGroups.getLoading() || requestProductGroups.getLoading()"
            :error="requestGroups.getError()"
            small
        >
            <template #cell(action)="{item}">
                <div class="d-flex gap-2 justify-content-end">
                    <ButtonIcon
                        v-if="!isInGroup(item.id)"
                        size="sm"
                        icon="folder-plus"
                        variant="primary"
                        :disabled="requestProductGroups.getLoading()"
                        :loading="requestGroupProducts.getLoading(`add-${item.id}`)"
                        @click="addItem(item)"
                    />
                    <ButtonIcon
                        v-if="isInGroup(item.id)"
                        size="sm"
                        icon="folder-minus"
                        variant="danger"
                        :disabled="requestProductGroups.getLoading()"
                        :loading="requestGroupProducts.getLoading(`remove-${item.id}`)"
                        @click="removeItem(item)"
                    />
                </div>
            </template>
        </DataTable>
    </b-modal>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'ModalAddProductToGroup',
        components: {
            DataTable,
        },
        data() {
            return {
                requestGroups: this.$req('producerProductGroups/spaceGroups'),
                requestGroupProducts: this.$req('producerProductGroups/groupProducts'),
                requestProductGroups: this.$req('producerProduct/groups'),
                product: null,
                productGroups: [],
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'description', label: this.$t('description') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            items() {
                return this.requestGroups.getData()?.items || [];
            },
        },
        watch: {
            product() {
                if (this.product) this.fetchProductGroups();
            },
        },
        methods: {
            onInit(product) {
                this.product = product;
            },
            fetchProductGroups() {
                return this.requestProductGroups
                    .get({ urlParams: { id: this.product.id }, requestParams: { page: 1, perPage: Number.MAX_SAFE_INTEGER } })
                    .then(data => (this.productGroups = data.items.reduce((acc, item) => ({ ...acc, [item.id]: item }), {})));
            },
            fetchGroups() {
                return this.requestGroups.get({ urlParams: { spaceId: this.spaceId }, requestParams: { page: 1, perPage: Number.MAX_SAFE_INTEGER, sort: 'id', order: 'DESC' } });
            },
            addItem(item) {
                return this.requestGroupProducts
                    .id(`add-${item.id}`)
                    .post({ urlParams: { groupId: item.id, id: this.product.id } })
                    .then(() => this.$set(this.productGroups, item.id, item))
                    .catch(error => {
                        if (error.errorCode === 'ALREADY_ADDED') {
                            this.$set(this.productGroups, item.id, item);
                        } else {
                            this.$toastr.error(error.message, this.$t('errorOccurred'));
                        }
                    });
            },
            removeItem(item) {
                return this.requestGroupProducts
                    .id(`remove-${item.id}`)
                    .delete({ urlParams: { groupId: item.id, id: this.product.id } })
                    .then(() => this.$delete(this.productGroups, item.id))
                    .catch(error => {
                        if (error.errorCode === 'NOT_RELATED') {
                            this.$delete(this.productGroups, item.id);
                        } else {
                            this.$toastr.error(error.message, this.$t('errorOccurred'));
                        }
                    });
            },
            isInGroup(id) {
                return !!this.productGroups[id];
            },
            resetData() {
                this.product = null;
            },
        },
        created() {
            this.fetchGroups();
        },
        mounted() {
            this.$root.$on('modal-add-product-to-group', this.onInit);
        },
        beforeDestroy() {
            this.$root.$off('modal-add-product-to-group', this.onInit);
        },
    };
</script>
